import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Set `document.title` to "<page> · حاضر" while the component is mounted.
 *
 * The browser tab is the only place a TA with three dashboards open can tell
 * which section they are looking at, so every route sets one.
 */
export function useDocumentTitle(title: string | undefined): void {
  const { t } = useTranslation();
  const appName = t('app.name');

  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} · ${appName}`;
    return () => {
      document.title = previous;
    };
  }, [title, appName]);
}
